// extracted by css-extract-rspack-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed__Ui4OU","compact":"DiffLines-module__compact__Rvh2a"};